/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Op_GtInputs */

const cs_op_gt = /** @type {(inputs: Op_GtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`>`)
};

const en_op_gt = /** @type {(inputs: Op_GtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`>`)
};

/**
* | output |
* | --- |
* | ">" |
*
* @param {Op_GtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const op_gt = /** @type {((inputs?: Op_GtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Op_GtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_op_gt(inputs)
	return cs_op_gt(inputs)
});